import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AchievementsService } from '../../../services/achievements.service';
import { BreakyComponent } from '../breaky/breaky.component';

/** Ventana de celebracion cuando el usuario consigue una o varias medallas nuevas. */
@Component({
  selector: 'app-medal-celebration',
  standalone: true,
  imports: [CommonModule, BreakyComponent],
  template: `
    <div *ngIf="pending$ | async as medals">
      <div *ngIf="medals.length" class="mc-backdrop" role="dialog" aria-modal="true">
        <div class="mc-card">
          <div class="mc-confetti" aria-hidden="true">🎉 ✨ 🎊 ✨ 🎉</div>
          <app-breaky pose="medal" [size]="130" motion="bounce"></app-breaky>
          <h2 class="mc-title">{{ medals.length === 1 ? '¡Nueva medalla!' : '¡Nuevas medallas!' }}</h2>
          <div class="mc-list">
            <div *ngFor="let m of medals" class="mc-medal">
              <span class="mc-icon">{{ m.icon }}</span>
              <strong class="mc-name">{{ m.name }}</strong>
              <span class="mc-desc">{{ m.description }}</span>
            </div>
          </div>
          <div class="mc-actions">
            <button type="button" class="mc-btn mc-btn--alt" (click)="seeAll()">Ver mis medallas</button>
            <button type="button" class="mc-btn" (click)="close()">¡Genial!</button>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .mc-backdrop { position: fixed; inset: 0; z-index: 10002; display: flex; align-items: center; justify-content: center; padding: 16px; background: rgba(2, 6, 23, 0.85); backdrop-filter: blur(4px); }
      .mc-card { width: 100%; max-width: 340px; max-height: 85vh; overflow-y: auto; padding: 20px 16px; text-align: center; border-radius: 22px; color: #fff; background: linear-gradient(160deg, #6d28d9, #be185d); box-shadow: 0 20px 50px rgba(0, 0, 0, 0.6); }
      .mc-confetti { font-size: 1.3rem; letter-spacing: 6px; }
      .mc-title { margin: 6px 0 12px; font-size: 1.4rem; font-weight: 800; }
      .mc-list { display: flex; flex-direction: column; gap: 10px; }
      .mc-medal { display: flex; flex-direction: column; align-items: center; gap: 2px; padding: 12px; border-radius: 16px; background: rgba(255, 255, 255, 0.14); }
      .mc-icon { font-size: 3rem; line-height: 1; animation: mc-pop 0.6s ease-out; }
      .mc-name { font-size: 1.05rem; }
      .mc-desc { font-size: 0.78rem; opacity: 0.92; }
      .mc-actions { display: flex; gap: 8px; margin-top: 16px; }
      .mc-btn { flex: 1; padding: 10px; border: 0; border-radius: 12px; font-weight: 800; font-size: 0.85rem; color: #0b131e; background: #facc15; cursor: pointer; }
      .mc-btn--alt { color: #fff; background: rgba(255, 255, 255, 0.2); }
      @keyframes mc-pop { 0% { transform: scale(0.2) rotate(-20deg); opacity: 0; } 70% { transform: scale(1.2) rotate(6deg); opacity: 1; } 100% { transform: scale(1) rotate(0); } }
      @media (prefers-reduced-motion: reduce) { .mc-icon { animation: none; } }
    `
  ]
})
export class MedalCelebrationComponent {
  constructor(private readonly achievements: AchievementsService, private readonly router: Router) {}

  get pending$() {
    return this.achievements.pending$;
  }

  close(): void {
    void this.achievements.dismissPending();
  }

  seeAll(): void {
    void this.achievements.dismissPending();
    void this.router.navigate(['/dashboard/mi-progreso'], { queryParams: { seccion: 'logros', tab: 'medallas' } });
  }
}
